<template>
    <div>
      <div class="container_equipamento">
        <GroupDetail
           :templateid="templateid"
           :dadosGrupo="dadosGrupo"
           :equipamento="equipamento"
           @editaSubEtapa="editaSubEtapa"
           @editarEtapa="editarEtapa"
           @voltaParaGrupo="voltaParaGrupo"
           @addNovaEtapa="addNovaEtapa"
           @addNovaSubEtapa="addNovaSubEtapa"
           @novaEtapaEquipamentoPergunta="novaEtapaEquipamentoPergunta"
           @addNovaSubEtapaObjSemNovaEtapa="addNovaSubEtapaObjSemNovaEtapa"
           @addNovaPerguntaParaSubEtapa="addNovaPerguntaParaSubEtapa"
           @addNovaPerguntaEtapaSubCriada="addNovaPerguntaEtapaSubCriada"
           @ExcluirPerguntaPerguntaEquipamentoCriado="ExcluirPerguntaPerguntaEquipamentoCriado"
           @ExcluirPerguntaEquipamento="ExcluirPerguntaEquipamento"
           @RemoverEdicaoExcluirPerguntaEquipamento="RemoverEdicaoExcluirPerguntaEquipamento"
           @ExcluirSubEtapasEtapas="ExcluirSubEtapasEtapas"
           @removerExclusaoEtapaSubEtapaEquipamento="removerExclusaoEtapaSubEtapaEquipamento"
           @EditaEquipamentoPergunta="EditaEquipamentoPergunta"
           @EditaEquipamentoNovaPergunta="EditaEquipamentoNovaPergunta"
           @editarEmMemoriaNovaPerguntaEtapaSubCriada="editarEmMemoriaNovaPerguntaEtapaSubCriada"
           @editarEmMemoriaNovaPerguntaParaSubEtapa="editarEmMemoriaNovaPerguntaParaSubEtapa"
           @editarEmMemoriaNovaPerguntaParaEtapa="editarEmMemoriaNovaPerguntaParaEtapa"
           @removerSubEtapaAgEnvioEtapa="removerSubEtapaAgEnvioEtapa"
           @removerSubEtapaEtapaCriada="removerSubEtapaEtapaCriada"
           @removerEtapaEquipamentoEstatica="removerEtapaEquipamentoEstatica"
           ref="grupoDetalhes"
        ></GroupDetail>
      </div>
    </div>
</template>

<script>
import equipmentTemplate from './equipmentTemplate'
export default equipmentTemplate
</script>
  <style scoped>
  .container_equipamento {
    width: 100%;
    height: fit-content;
    margin-top: 2rem;
  }

 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/equipmentTemplate/equipmentTemplate.vue